import { liteClient as algoliasearch } from "./node_modules/algoliasearch/dist/lite/builds/browser.js";
import instantsearch from "./node_modules/instantsearch.js/es/index.js";
import {
  searchBox,
  hits,
  configure,
} from "./node_modules/instantsearch.js/es/widgets/index.js";
import { connectPagination } from './node_modules/instantsearch.js/es/connectors';

const renderPagination = (renderOptions, isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
    widgetParams,
  } = renderOptions;

  const container = widgetParams.container;

  container.innerHTML = `
  <p>
    Results Page:
    <b>
    ${
      !isFirstPage
        ? `<a href="${createURL(0)}" data-value="${0}"><<</a>`
          + ` `
          + `<a href="${createURL(currentRefinement - 1)}" data-value="${currentRefinement - 1}"><</a>`
          + ` `
        : ''
    }

    ${pages.map((page) => (currentRefinement === page
      ? `<b>${page + 1}</b>`
      : `<a href="${createURL(page)}" data-value="${page}">${page + 1}</a>`
      ) + " "
    ).join('')}

    ${
      !isLastPage
        ? `<a href="${createURL(currentRefinement + 1)}" data-value="${currentRefinement + 1}">></a>`
          + ` `
          + `<a href="${createURL(nbPages - 1)}" data-value="${nbPages - 1}">>></a>`
        : ''
    }
    </b>
  </p>
  `;

  [...container.querySelectorAll('a')].forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      refine(event.currentTarget.dataset.value);
    });
  });
};

class AlgoliaSearch extends HTMLElement {
  constructor() {
    // establish prototype chain
    super();

    // attaches shadow tree and returns shadow root reference
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/attachShadow
    const shadow = this.attachShadow({ mode: 'open' });

    const appId = this.getAttribute("app-id");
    const apiKey = this.getAttribute("api-key");
    const indexName = this.getAttribute("index");

    const styles = document.createElement("style");
    styles.textContent = `
    :host {
      display: block;
    }
    `;
    shadow.prepend(styles);

    const searchBoxContainer = document.createElement("div");
    searchBoxContainer.part = "search box";

    const hitsContainer = document.createElement("div");
    hitsContainer.part = "search results";

    const paginator = document.createElement("div");
    paginator.part = "search pagination";

    this.appendChild(searchBoxContainer);
    this.appendChild(hitsContainer);
    this.appendChild(paginator);

    shadow.innerHTML = "<slot></slot>";

    const search = instantsearch({
      indexName,
      searchClient: algoliasearch(appId, apiKey),
      initialUiState: {
        [indexName]: {
          query: new URLSearchParams(window.location.search).get("q"),
        },
      },
      onStateChange({ uiState, setUiState }) {
        if (!uiState[indexName]?.query) {
          hitsContainer.classList.add("hide-content");
          setUiState(uiState);
          return;
        }

        hitsContainer.classList.remove("hide-content");
        setUiState(uiState);
      },
    });

    search.addWidgets([
      searchBox({
        container: searchBoxContainer,
        placeholder: this.getAttribute("placeholder"),
        autofocus: this.hasAttribute("autofocus"),
        searchAsYouType: this.hasAttribute("search-as-you-type"),
        showReset: false,
      }),
      configure({
        hitsPerPage: Number(this.getAttribute("per-page")) || 15,
      }),
      hits({
        container: hitsContainer,
        templates: {
          empty(results, { html }) {
            return html`No results for <q>${results.query}</q>`;
          },
          item: (hit, { html, components }) => html`
          <p>
            <a href="${hit.url}">
              ${components.Highlight({ hit, attribute: "title" })}
            </a>
            <br />
            ${components.Highlight({ hit, attribute: "description" })}
          </p>
          `,
        },
      }),
      connectPagination(renderPagination)({
        container: paginator,
      }),
    ]);

    search.start();
  }

  // fires after the element has been attached to the DOM
  connectedCallback() {
  }
}

// let the browser know about the custom element
customElements.define("algolia-search", AlgoliaSearch);
